import { Pie, type PieProps } from 'recharts'

const GaugeHalfPie = (props: PieProps) => (
  <Pie
    {...props}
    stroke="none"
    dataKey="value"
    startAngle={180}
    endAngle={0}
    cx="50%"
    cy="100%"
    innerRadius="150%"
    outerRadius="200%"
    cornerRadius={1}
    paddingAngle={2}
  />
)

export default GaugeHalfPie
